import createProductLayout from '../../main-layout/createProductLayout';
import Body from '../../main-layout/body/Body';
import ButtonContainer from '../../main-layout/cta-components/ButtonContainer';
import ViSmallCardHeader from './ViSmallCardHeader';
import { smallCardGrid } from '../small-card-layout/styles';
import ViSmallCardReadMore from './ViSmallCardReadMore';
const ViSmallCardLayout = createProductLayout({
  coreComponents: {
    Header: ViSmallCardHeader,
    Body,
    ReadMore: ViSmallCardReadMore,
    Cta: ButtonContainer
  },
  defaultGrid: smallCardGrid,
  mouseFlowTag: 'Small card'
});
export default ViSmallCardLayout;
//# sourceMappingURL=ViSmallCardLayout.js.map